// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"a12be113","114":"f1449453","241":"e8d2ad0b","312":"5215432f","543":"b45edbf8","786":"24606fbf","975":"78b5f3d6","980":"af057ff1"}[chunkId] + ".chunk.css";
};